import React from 'react';
import ReactDOM from 'react-dom/client';
// Lettertypes van eigen server (Fontsource) in plaats van Google Fonts: zo gaat
// het IP-adres van een bezoeker niet naar Google. Webpack zet de bestanden met
// een hash in build/static/media. Alleen de gewichten die de site gebruikt.
// Poppins (koppen op de publieke pagina's): ook alle tekensets, zodat een naam
// als Yaşar of Łukasz in een kop niet in een andere letter staat (bevinding 111,
// 19-10-2026). Dankzij unicode-range haalt de browser latin-ext pas op als zo'n
// teken op de pagina staat.
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
// DM Sans en Inter tonen ook namen en vraagteksten (ş, ğ, ł, Griekse letters).
// Daarom alle tekensets, net als bij Google Fonts; de browser haalt via
// unicode-range alleen de tekenset op die op de pagina nodig is.
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './design-system/index.css';
import './index.css';
import App from './App';
import { bewaarVoorgerenderd, isVoorrenderen, magVoorrenderen } from './utils/voorgerenderd';

const container = document.getElementById('root');
if (isVoorrenderen() && !magVoorrenderen(window.location.pathname)) {
  // react-snap slaat deze pagina leeg op, net als 200.html: zie NIET_VOORRENDEREN
  // in utils/voorgerenderd.js (inlogpagina's en /check, 24-10-2026).
} else {
  // Voorgerenderde HTML (react-snap) bewaren vóór React hem vervangt: die blijft
  // staan tot de code van de pagina geladen is, zie VoorgerenderdeFallback.
  bewaarVoorgerenderd(container);
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
